import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppFrequencyHoursAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Frequency Hours"
		placeholder="All Frequency Hours"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/frequency-hours`}
		{...props}
	/>
}